import { css } from 'styled-components';

const selects = css`
  .primarySelect {
    display: inline-block;
    width: 50%;
    height: 2rem;
    padding: .375rem .75rem .375rem .75rem;
    line-height: 1.5;
    vertical-align: middle;
    color: var(--primary-text-color,#fff);
    background: var(--primary-background-color,#000);
    border: 1px solid #ced4da;
    border-radius: .25rem;
  }
`

export default selects
